export default "__VITE_PUBLIC_ASSET__eb3ccdef__"